import "@/styles/main.scss";

import BaseHelpers from './helpers/base-helpers';
import PopupManager from './modules/popup-manager';
import BurgerMenu from './modules/burger-menu';
// import Tabs from './modules/tabs';
// import Accordion from './modules/accordion';
import SearchBar from './modules/search-bar';
import { Splide } from './modules/splide';
import './modules/post-scroll';
import './modules/load-more';
import './modules/load-more-category';
import './modules/load-more-dumky';

BaseHelpers.checkWebpSupport();

BaseHelpers.addTouchClass();

BaseHelpers.addLoadedClass();

/**
 * BaseHelpers methods has intellisense descriptions
 */
// BaseHelpers.headerFixed();
BaseHelpers.headerScrollUpTrigger();
BaseHelpers.placeholderReplacer();
BaseHelpers.creatorReplacer();
BaseHelpers.titleTapeProcessor();
BaseHelpers.containerToggler();
// BaseHelpers.splideChecker();
BaseHelpers.containlessPostImages();
// BaseHelpers.navigationActive();
// BaseHelpers.dynamicSectionExtractor();
// BaseHelpers.floatingTooltips();
// BaseHelpers.specialNewsReplacer();
// BaseHelpers.firstArticleExtractor();

/**
 * Открытие/закрытие модальных окон
 * Чтобы модальное окно открывалось и закрывалось
 * На окно повешай атрибут data-popup="<название окна>"
 * На кнопку, которая вызывает окно повешай атрибут data-type="<название окна>"

 * На обертку(.popup) окна добавь атрибут '[data-close-overlay]'
 * На кнопку для закрытия окна добавь класс '.button-close'
 * */
new PopupManager();

/**
 *  Модуль для работы с меню (Бургер)
 * */
new BurgerMenu().init();

/**
 *  Search in header module
 * */
new SearchBar().init();

/**
 *  Библиотека для анимаций
 *  документация: https://michalsnik.github.io/aos
 * */
// AOS.init();

/**
 * Параллакс мышей
 * */
// new MousePRLX();

// document.addEventListener( 'DOMContentLoaded', function() {
// BaseHelpers.scrollIntoMobileNavActive();
// } );

// new Accordion('.accordion', {
// 	shouldOpenAll: false, // true
// 	defaultOpen: [], // [0,1]
// 	collapsedClass: 'open',
// });
document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector(
        '.search-bar__input input[type="text"]'
    );
    const socialList = document.querySelector('.social-list');

    searchInput.addEventListener('focus', function () {
        socialList.classList.add('social-list-hidden');
    });

    searchInput.addEventListener('blur', function () {
        const screenWidth = window.innerWidth;
        let delay;

        if (screenWidth >= 1225) {
            delay = 240;
        } else {
            delay = 290;
        }

        setTimeout(() => {
            socialList.classList.remove('social-list-hidden');
        }, delay);
    });
});